import React from "react";
import {
  GlobeAltIcon,
  LightningBoltIcon,
  ScaleIcon,
  ArrowRightIcon,
  ArrowLeftIcon,
} from "@heroicons/react/outline";

// Import channel images
import EmailImage from "./../images/channelList/email.png";
import FacebookAdImage from "./../images/channelList/fbc.png";
import GoogleAdImage from "./../images/channelList/gac.png";
import PopupImage from "./../images/channelList/popup.png";
import SmsImage from "./../images/channelList/sms.png";
import WebPushImage from "./../images/channelList/webpush.png";
import MobilePushImage from "./../images/channelList/mobilepush.png";
import WhatsAppImage from "./../images/channelList/whatsapp.png";
import InAppImage from "./../images/channelList/inapp.png";

var interval = null;

export default class ChannelList extends React.Component {
  constructor(props) {
    // Init props and state
    super(props);
    this.state = {
      channels: [
        {
          name: "Email",
          title: "Email Marketing",
          image: EmailImage,
          description:
            "Engage users with personalized emails at the right moment and increase your brand loyalty. Build beautiful emails using our templates and a drag & drop email editor.",
        },
        {
          name: "SMS",
          title: "SMS Marketing",
          image: SmsImage,
          description:
            "Use SMS for engage users offline with personalized and actionable messages. Personalize your SMS with user data to provide exceptional brand experience.",
        },
        {
          name: "WhatsApp",
          title: "WhatsApp Messages",
          image: WhatsAppImage,
          description:
            "Reach out to your offline customers on their favourite channel WhatsApp with personalized and contextul messages.",
        },
        {
          name: "Web Push Notifications",
          title: "Web Push Notifications",
          image: WebPushImage,
          description:
            "Engage with users on desktop and mobile – even when they are not on your site. Use Growlytics’ data driven Web Push campaingns to create unique customer experiences.",
        },
        {
          name: "Mobile Push Notifications",
          title: "Mobile Push Notifications",
          image: MobilePushImage,
          description:
            "Use Growlytics to personalize your push messaging to reflect specific customer behaviors, interests, preferences, and more.",
        },
        {
          name: "In-app Displays",
          title: "In-app Displays",
          image: InAppImage,
          description:
            "Use Growlytics to personalize your push messaging to reflect specific customer behaviors, interests, preferences, and more.",
        },
        {
          name: "Facebook & Instagram",
          title: "Facebook & Instagram",
          image: FacebookAdImage,
          description:
            "Focus on delivering a more personalized experience without the need to re-create an audience in Facebook. Enhance Facebook targeting with the power of your customer data.",
        },
        {
          name: "Google Ads",
          title: "Google Ads",
          image: GoogleAdImage,
          description:
            "Sync your customer segments with your Google Ads account. Target your customers on google search, Shopping, Gmail, and Youtube.",
        },
        {
          name: "Popups & Flyouts",
          title: "Popups & Flyouts",
          image: PopupImage,
          description:
            "Grow your email & SMS list with popups, flyouts, and other high-converting displays.",
        },
      ],
      activeChannel: null,
      allFeatures: [
        {
          icon: GlobeAltIcon,
          title: "Grow Your Customer List",
          description:
            "Grow your email and SMS list with Popups, Flyouts and other high-converting displays.",
        },
        {
          icon: LightningBoltIcon,
          title: "Cross-channel Automation",
          description:
            "Drive more revenue with multi-channel automation built for e-commerce, with ready made automation templates.",
        },
        {
          icon: ScaleIcon,
          title: "Advanced Segments & Reports",
          description:
            "Drive action from your consumers at each stage of their lifecycle.",
        },
      ],
    };
    this.state.activeChannel = this.state.channels[0];
    this.startTimerForChange();
  }

  onChannelSelected(index) {
    this.state.activeChannel = this.state.channels[index];
    this.setState(this.state);
  }

  startTimerForChange() {
    if (interval != null) {
      clearTimeout(interval);

      let activeIndex = -1;

      for (let i = 0; i < this.state.channels.length; i++) {
        if (this.state.channels[i].name == this.state.activeChannel.name) {
          activeIndex = i;
          break;
        }
      }
      if (activeIndex >= this.state.channels.length - 1) {
        activeIndex = -1;
      }

      this.state.activeChannel = this.state.channels[activeIndex + 1];
      this.setState(this.state);
    }

    interval = setTimeout(() => {
      this.startTimerForChange();
    }, 8000);
  }

  onNextChannelClick() {
    let activeIndex = 0;
    for (let i = 0; i < this.state.channels.length; i++) {
      if (this.state.channels[i].name == this.state.activeChannel.name) {
        activeIndex = i;
        break;
      }
    }
    activeIndex = activeIndex + 1;
    if (activeIndex >= this.state.channels.length) activeIndex = 0;
    this.onChannelSelected(activeIndex);
  }

  onPrevChannelClick() {
    let activeIndex = 0;
    for (let i = 0; i < this.state.channels.length; i++) {
      if (this.state.channels[i].name == this.state.activeChannel.name) {
        activeIndex = i;
        break;
      }
    }
    activeIndex = activeIndex - 1;
    if (activeIndex < 0) activeIndex = this.state.channels.length - 1;
    console.log("set index", activeIndex);
    this.onChannelSelected(activeIndex);
  }

  render() {
    return (
      <div className="relative py-2 bg-primary-10 overflow-hidden bg-gray-50">
        <div className="absolute inset-y-0 h-full w-full" aria-hidden="true">
          <div className="relative h-full lg:mx-auto lg:max-w-7xl overflow-hidden">
            <svg
              className="absolute right-full transform translate-y-1/3 translate-x-1/4 md:translate-y-1/2 sm:translate-x-1/2 lg:translate-x-full"
              width={404}
              height={784}
              fill="none"
              viewBox="0 0 404 784"
            >
              <defs>
                <pattern
                  id="e229dbec-10e9-49ee-8ec3-0286ca089edf"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={784}
                fill="url(#e229dbec-10e9-49ee-8ec3-0286ca089edf)"
              />
            </svg>
            <svg
              className="absolute left-full transform -translate-y-3/4 -translate-x-1/4 sm:-translate-x-1/2 md:-translate-y-1/2 lg:-translate-x-3/4"
              width={604}
              height={886}
              fill="none"
              viewBox="0 0 604 886"
            >
              <defs>
                <pattern
                  id="d2a68204-c383-44b1-b99f-42ccff4e5365"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={604}
                height={886}
                fill="url(#d2a68204-c383-44b1-b99f-42ccff4e5365)"
              />
            </svg>
          </div>
        </div>

        {/* Desktop View */}
        <div className="hidden md:flex lg:mx-auto lg:max-w-7xl mt-0 pb-5">
          <div
            className="flex-0 pl-5 pb-10"
            style={{ width: "400px", zIndex: "9999" }}
          >
            {this.state.channels.map((channel, index) => {
              return (
                <div key={index} className="font-bold text-gray-500">
                  {/* // If Active Channel */}
                  {this.state.activeChannel.name == channel.name && (
                    <div
                      className="text-black cursor-pointer text-secondary-500 rounded-md p-3"
                      style={{ background: "#9eb4b75e" }}
                      onClick={() => {
                        this.onChannelSelected(index);
                      }}
                    >
                      <div className="w-9 inline-block">0{index + 1}</div>
                      {channel.name}
                      <div
                        style={{
                          float: "right",
                          width: "80px",
                        }}
                      >
                        <div
                          className="rounded bg-secondary progressLoader"
                          style={{ marginTop: "12px" }}
                        ></div>
                      </div>
                    </div>
                  )}

                  {/* If In-active Channel */}
                  {this.state.activeChannel.name != channel.name && (
                    <div
                      className="cursor-pointer p-4"
                      onClick={() => {
                        this.onChannelSelected(index);
                      }}
                    >
                      <div className="w-9 inline-block">0{index + 1}</div>
                      {channel.name}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="flex-1 mt-12 sm:mt-16 lg:mt-0 flex flex-col pl-20">
            <div
              style={{ width: "55%", zIndex: "9999" }}
              className="text-left border-1 ml-0 pt-4 pl-10 font-bold text-primary text-2xl"
            >
              {this.state.activeChannel.title}
            </div>
            <div
              style={{ width: "75%", zIndex: "9999" }}
              className="text-left border-1 ml-0 pt-2 pl-10 text-gray-500 mb-6"
            >
              {this.state.activeChannel.description}
            </div>
            <img
              className="ml-5"
              style={{ width: "600px", zIndex: "9999" }}
              src={this.state.activeChannel.image}
              alt="Segment Builder"
            />
          </div>
        </div>

        {/* Mobile View */}
        <div className="block md:hidden mt-0 pb-5 px-2">
          <div className="mt-4 lg:mt-0 flex flex-col px-2">
            {/* title */}
            <div style={{ zIndex: "9999" }} className="relative flex">
              <div className="text-sm text-secondary-200 flex pr-2 absolute -right-2 top-3">
                <div
                  className="border-2 border-primary bg-primary-50 rounded-full mr-2"
                  style={{ padding: "8px" }}
                  onClick={() => {
                    this.onPrevChannelClick();
                  }}
                >
                  <ArrowLeftIcon className="h-4 w-4 text-primary"></ArrowLeftIcon>
                </div>
                <div
                  className="border-2 border-primary bg-primary-50 rounded-full"
                  style={{ padding: "8px" }}
                  onClick={() => {
                    this.onNextChannelClick();
                  }}
                >
                  <ArrowRightIcon className="h-4 w-4 font-bold text-primary"></ArrowRightIcon>
                </div>
              </div>
              <div className="text-left border-1 font-bold text-primary text-2xl flex-1">
                <div className="text-sm text-gray-700 flex-1">
                  Marketing Channels
                </div>
                <div className="text-md">{this.state.activeChannel.title}</div>
              </div>
            </div>

            {/* Description */}
            <div
              style={{ zIndex: "9999" }}
              className="text-left border-1 ml-0 pt-2 text-gray-500"
            >
              {this.state.activeChannel.description}
            </div>

            <div className="relative mt-6" style={{ zIndex: "9999" }}>
              {/* Channel Image */}
              <img
                className="mt-6"
                style={{ zIndex: "9999", width: "100%", height: "auto" }}
                src={this.state.activeChannel.image}
                alt={this.state.activeChannel.name}
              />
            </div>
          </div>

          <div
            className="px-20 mt-6 text-secondary-200 justify-center align-items-center flex"
            style={{ zIndex: "9999" }}
          >
            {this.state.channels.map((channel, index) => {
              return (
                <div key={index} className="flex-1" style={{ zIndex: "9999" }}>
                  <div
                    className={
                      "rounded-full " +
                      (channel.name == this.state.activeChannel.name
                        ? "bg-secondary"
                        : "bg-primary-50")
                    }
                    style={{
                      width: "12px",
                      height: "12px",
                      marginTop: "5px",
                      marginLeft: "4px",
                    }}
                  ></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
